import axios from 'axios'
import { useLocation } from 'react-router-dom'

const api = '/external/companies/ipp/accessurl'
const redirect = async (accessCode) => {
  const instance = axios.create({
    method: 'GET',
    baseURL: `${API_BASE_PATH}`
  })
  const response = await instance.request(`${api}?accessCode=${accessCode}`)
  window.location.replace(response.data.data.accessURL)
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}
const IppPostings = () => {
  const query = useQuery()
  const accessCode = query.get('accessCode')
  return (redirect(accessCode))
}

export default IppPostings
